module.exports = __webpack_public_path__ + "assets/images/tijolo_492e6e6f6415a4bb8d546e75d19930d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/paralelepipedo/tijolo.png
// module id = 210
// module chunks = 0